import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import styles from '../styles/uikitModalsModalHeader.module.scss';

const ModalHeader = ({ modal }) => {
  if (!modal.title && !modal.body) return null;

  const { isFullScreen } = modal;

  return (
    <div className={classnames(styles.element, isFullScreen && styles.isFullScreen)}>
      {modal.title && (
        <Typo
          className={styles.title}
          element="h3"
          title={modal.title}
          variant={isFullScreen ? 'd05' : 'd03'}
          weight="medium"
        >
          {modal.title}
        </Typo>
      )}
      {modal.body && (
        <Typo element="p" variant="b01" className={styles.body}>{modal.body}</Typo>
      )}
    </div>
  );
};

ModalHeader.propTypes = {
  modal: PropTypes.shape({
    isFullScreen: PropTypes.bool,
    title: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
};

export default ModalHeader;
